import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=4eba6a79&scoped=true&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba6a79",
  null
  
)

export default component.exports